"use strict";

exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/getDisplayName.js
// module id = 189
// module chunks = 104158497352714 128747004913641